import { AccountCircle, Assignment, AssistantDirection, Cancel, Chat, Close, CloseOutlined, Edit, HighlightOffRounded, InfoOutlined, NavigateNext, PersonOutline } from '@mui/icons-material';
import { Badge, Box, Button, Card, Chip, Dialog, DialogContent, Fab, FormControl, Grid, IconButton, MenuItem, Modal, Paper, Rating, Select, Snackbar, SnackbarContent, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from '@mui/material';
import React, { createContext, useEffect, useState } from 'react';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { ProviderServices } from '../../Provider/CrudServices';
import { formatDateTime } from '../../../utils/dateUtils';
import { useForm, Controller, set } from 'react-hook-form';
import Swal from 'sweetalert2';
import { PermissionGuard } from '../../../components/PermissionGuard';
import { isMobile } from 'react-device-detect';
import ChatBox from './ChatBox';
import PaymentDetails from './PaymentDetails';
import { useParams } from 'react-router-dom';
import { BookingService } from '../Service';
import Loading from '../../../components/Loader/Loading';
import OtpSection from './OtpSection';
import { LocalStore } from '../../../storage/authStore';
import CancelAndReschedule from './cancelAndReschedule/CancelAndReschedule';
import BookingLogs from './BookingLogs';
import ApplyDiscount from './ApplyDiscount';
import LinkIcon from '@mui/icons-material/Link';
import axios from 'axios';
import IsTestBooking from './IsTestBooking';
import CouponAmountCalculator from './CouponAmountCalculator';
import { RoleGuard } from '../../../components/RoleGuard';
import pdfLogo from "../../../assets/images/pdf-icon-4.png";

dayjs.extend(customParseFormat);

const BookingDetailsContext = createContext();

const Viewdetails = ({ selectedBookingDetails, bookingId ,setPaymentMethod,setBookingStatus,setBookingServiceDate }) => {
    const loggedUser = LocalStore.getLoggedUserDetails();
    // const {bookingId} = useParams();
    const [isloading, setIsLoading] = useState(false);
    const [bookingDetailsdata, setbookingDetailsdata] = useState({});
    const [chargeDetails,setChargeDetails] = useState([]);
    const fetchBookingDetalById = async () => {
        setIsLoading(true);
        try {
            const response = await BookingService.bookingDetailById(bookingId);
            console.log('Booking Details:', response);
            const data = response.data;
            setbookingDetailsdata(response.data);
            setValue('bookingStatus', data?.bookingStatus);
            setBookingStatus(data?.bookingStatus);
            setBookingServiceDate(data?.serviceDate)
            setPaymentMethod(response.data?.payment?.paymentMethod);
            setChargeDetails(()=> [
                    // { label: "Sub-Total", value: parseFloat(bookingDetailsdata?.subTotal) },
                    { label: "Platform Fee", value: parseFloat(data?.platformCharges),color:'#000000de' },
                    { label: "Convenience Fee", value: parseFloat(data?.convenienceFee),color:'#000000de' },
                    { label: `Discount`, value: parseFloat(data?.discount) ||0.00,color:'#d32f2f' },
                    { label: "Cudel Coins Used", value: parseFloat(data?.coinValue),color:'#d32f2f' },
                    { label: `Coupon Applied`, value: parseFloat(data?.couponAmount) ||0.00,color:'#d32f2f' },
                    { label: "Visiting Charges", value: parseFloat(data?.visitingCharge),color:'#000000de' },
                    { label: "Taxes", value: parseFloat(data?.tax),color:'#000000de' }
                ].filter(charge => charge.label === 'Coupon Applied' || charge.value > 0 || ['Platform Fee', 'Convenience Fee', 'Visiting Charges'].includes(charge.label)));
            setIsLoading(false);
        }
        catch (error) {
            console.log('Error:', error);
            setIsLoading(false);
        } 

    }
    useEffect(() => {
        if (selectedBookingDetails) {
            setbookingDetailsdata(selectedBookingDetails);
        } else if (bookingId) {
            fetchBookingDetalById();
            fetchMessages();
        }
    }, [selectedBookingDetails, bookingId])
    const { control, watch, setValue } = useForm({
        defaultValues: {
            bookingStatus: bookingDetailsdata?.bookingStatus
        }
    });
    const [changeBookingStatus, setChangeBookingStatus] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(true);

    const bookingStatus = watch('bookingStatus');
    const changeBookingStatusHandler = async () => {
        const result = await Swal.fire({
            text: `Are you sure you want to change the booking status from ${bookingDetailsdata?.bookingStatus} to ${bookingStatus} now?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, change now!',
            cancelButtonText: 'No, Cancel',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showCloseButton: false,
        });
        if (result.isConfirmed) {
            try {
                Swal.fire({
                  title: 'Processing...',
                  text: 'Please wait while we updaing status',
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                  showConfirmButton: false,
                  didOpen: () => {
                    Swal.showLoading();
                  }
                });
                // Call your API to update the status
                let response;
                if(bookingStatus == 'accepted'){
                    response = await BookingService.acceptBooking( bookingId,bookingDetailsdata?.providerId );
                } else {
                    response = await BookingService.modifyBookingStatus({
                        bookingId: bookingId,
                        currentStatus: bookingDetailsdata?.bookingStatus,
                        providerId:bookingDetailsdata?.providerId,
                    });
                }
                console.log('Response:', response);
                if (response.success == '1' || response.status == 'success') {
                    // setAccountStatus(newStatus);
                    setChangeBookingStatus(false);
                  fetchBookingDetalById();
                  Swal.fire({
                    title: 'Status Updated',
                    text: 'Status has been successfully updated',
                    icon: 'success',
                    timer: 1500
                  });

                  return true;
                } else {
                  await Swal.fire({
                    icon: 'error',
                    title: 'Error!',
                      text: response.message || 'Failed to update booking status',
                    allowOutsideClick:false
                  });
                  return false;
                }
            } catch (error) {
                await Swal.fire({
                  title: 'Update Failed',
                  text: error.message || 'Failed to update booking status',
                    icon: 'error',
                  allowOutsideClick:false
                });
            }
            Swal.fire('Status Changed!', '', 'success')
        } else {
            return false;
        }
    }

    const [openItemDetails, setOpenItemDetails] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const handleViewItemDetails = (item) => {
        setSelectedItem(item);
        setOpenItemDetails(true);
    };
    useEffect(() => {
        if (bookingStatus && bookingStatus !== bookingDetailsdata?.bookingStatus) {
            changeBookingStatusHandler();
        }
    }, [bookingStatus])
    const [showChat, setShowChat] = useState(false);

    const [openDiscountModal, setOpenDiscountModal] = useState(false);

    const removeCouponDiscount = async () => {
        // Add your logic to apply the discount here
        const isConfirmed = await Swal.fire({
            title: 'Are you sure?',
            text: `You are about to remove the coupon code ${bookingDetailsdata?.couponDetails.couponCode}`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Remove it!',
            cancelButtonText: 'No, cancel!',
            allowOutsideClick: false,
        });
        if (isConfirmed.isConfirmed) {
            Swal.fire({
                title: 'Processing...',
                text: 'Please wait while we removing the coupon.',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                },
            });
            try {

                const discountResponse = await BookingService.afterBookingCouponApply({
                    "bookingId": bookingDetailsdata?.id,
                    "timeSlotDate": bookingDetailsdata?.serviceDate,
                    "startTime": bookingDetailsdata.bookingStartTime,
                    "endTime": bookingDetailsdata.bookingEndTime,
                    "useCoin": bookingDetailsdata?.coinValue > 0 ? true : false,
                    "couponCode": '',
                });

                if (discountResponse.success == "1") {
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Discount Removed successfully',
                    });
                    fetchBookingDetalById();
                    Swal.close();
                    setOpenDiscountModal(false);
                }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Something Went wrong. Please try again.',
                });
                console.error("Error in removing discount coupon:", error);
            }
        }
    }
    const [openTooltip, setOpenTooltip] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);

    const handleCopy = () => {
        navigator.clipboard.writeText(
            `https://www.google.com/maps/dir/?api=1&destination=${bookingDetailsdata?.add_latitude},${bookingDetailsdata?.add_longitude}`
        );
        setOpenTooltip(false); // Hide the tooltip
        setSnackbarOpen(true); // Show snackbar
    };

    const handleOpenInNewTab = () => {
        window.open(
            `https://www.google.com/maps/dir/?api=1&destination=${bookingDetailsdata?.add_latitude},${bookingDetailsdata?.add_longitude}`,
            '_blank'
        );
        setOpenTooltip(false);
    };
    const environment = process.env.REACT_APP_ENV_MODE;
    const productionUrl = process.env.REACT_APP_CHAT_API_PROD_URL;
    const stagingUrl = process.env.REACT_APP_CHAT_API_DEV_URL;
    const chatKey = environment == 'development' ? process.env.REACT_APP_CHAT_API_KEY_DEV : process.env.REACT_APP_CHAT_API_KEY;
    const [isChatLoading, setIsChatLoading] = useState(false);
    const [badgeContent, setBadgeContent] = useState(0);
    const [messages, setMessages] = useState([]);
    const fetchMessages = async () => {
        setIsChatLoading(true);

        try {
            // const response = await axios.get(`https://staging-api-chat.cudel.in/api/getChatDetails/818`, {
            const response = await axios.get(`${environment == 'development' ? stagingUrl : productionUrl}/api/getChatDetails/${bookingId}`, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    "X-API-Key": chatKey,
                },
                withCredentials: true
            }).
                then((response) => {
                    console.log(response.data);
                    setMessages(response.data.messages);
                    setBadgeContent(response.data.messages.length);
                    setIsChatLoading(false);
                });
        } catch (error) {
            console.error('Error fetching messages:', error);
            setMessages([]);
            // setIsLoading(false);
        }
    };
    // useEffect(() => {
    // }, []);
    const downloadInvoice = async (bookingId) =>{
        const isresult = await Swal.fire({
            title: 'Do you want to download the invoice?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Download it!',
            cancelButtonText: 'No, cancel!',
             allowOutsideClick: false,
        })
        if(isresult.isConfirmed){
            // show loading
            Swal.fire({
                title: 'Generating Invoice...',
                text: 'Please wait while we generate the invoice for you.',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                },
            });
            const response = await BookingService.downloadPdfInvoice(bookingId);
            console.log('Invoice Response:', response.success);
            if(response.success){   
                Swal.close();     
                window.open(response.fileUrl, '_blank');
            } else {
                Swal.fire({
                    title: 'Error!',
                    text: 'Failed to download invoice. Please try again later.',
                    icon: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false,
                });
            }
        }
    }
    return (
        <BookingDetailsContext.Provider value={{ bookingDetailsdata, setbookingDetailsdata, fetchBookingDetalById }}>
            {isloading && <Loading />}
            <Grid container spacing={1}>
                <Grid item xs={12} md={8.5}>
                    <Card>
                        <Box sx={{ display: { xs: 'block', sm: 'flex' }, justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid lightGray', p: '1% 2%' }}>
                            <Typography fontWeight={'600'} sx={{ fontSize: '0.85rem' }}>Booking Number : <Box component={'span'} sx={{ color: '#1976d2', fontSize: '0.75rem' }}>{bookingDetailsdata?.bookingNumber}</Box>                            </Typography>
                            <Typography fontWeight={'600'} sx={{ fontSize: '0.85rem' }}>Service Date : <Box component={'span'} sx={{ color: '#1976d2', fontSize: '0.75rem' }}>{bookingDetailsdata?.serviceDate ? formatDateTime(bookingDetailsdata?.serviceDate, 'date') : ''}</Box></Typography>
                            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                                <Typography fontWeight={'600'} sx={{ fontSize: '0.85rem' }}>Status: </Typography>

                                {/* //  sx={{textTransform:'uppercase',color:bookingDetailsdata?.bookingStatus === 'requested' ? '#E8832A' : bookingDetailsdata?.bookingStatus === "rejected"?'#F80000':bookingDetailsdata?.bookingStatus === 'completed'?'#009EB4':bookingDetailsdata?.bookingStatus === 'accepted'?'#40B962': bookingDetailsdata?.bookingStatus === 'cancelled'?'#D81A23':bookingDetailsdata?.bookingStatus === 'ongoing'?'#1A44B8':'default',fontSize:'0.75rem'}}>{bookingDetailsdata?.bookingStatus} */}
                                {changeBookingStatus ?
                                    <>
                                        <FormControl size="small" fullWidth >
                                            <Controller
                                                name="bookingStatus"
                                                control={control}
                                                // defaultValue=""
                                                render={({ field }) => (
                                                    <Select
                                                        {...field}                                                        
                                                        sx={{
                                                            minHeight: '0px',
                                                            height: '1.6rem',
                                                            fontSize: '0.65rem',
                                                            // fontWeight: '600',
                                                            '& .MuiSelect-select': {
                                                                padding: '0 .5rem', // Adjust horizontal padding as needed
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                            },
                                                        }}
                                                    >
                                                        <MenuItem sx={{ fontSize: '0.65rem',display:'none' }} value='requested'>Requested</MenuItem>
                                                        <MenuItem sx={{ fontSize: '0.65rem'  }} value='accepted'>Accepted</MenuItem>
                                                        <MenuItem sx={{ fontSize: '0.65rem',display:'none'  }} value='rejected'>Rejected</MenuItem>
                                                        <MenuItem sx={{ fontSize: '0.65rem',display:'none'  }} value='cancelled'>Cancelled</MenuItem>    
                                                        <MenuItem sx={{ fontSize: '0.65rem'  }} value='completed'>Completed</MenuItem>
                                                        <MenuItem sx={{ fontSize: '0.65rem',display:'none'  }} value='ongoing'>Ongoing</MenuItem>
                                                    </Select>
                                                )}
                                            />
                                        </FormControl>
                                        <IconButton size='small' color='error' sx={{ fontSize: '0.85rem' }} onClick={() => setChangeBookingStatus(false)}><Cancel sx={{ fontSize: '1rem' }} /></IconButton>
                                    </>
                                    :
                                    <>
                                        <Chip
                                            label={bookingDetailsdata?.bookingStatus}
                                            size="small"
                                            sx={{
                                                // ml:1,
                                                fontSize: '0.75rem',
                                                fontWeight: '500',
                                                color: bookingDetailsdata?.bookingStatus === 'requested' ? '#E8832A' : bookingDetailsdata?.bookingStatus === "rejected" ? '#F80000' : bookingDetailsdata?.bookingStatus === 'completed' ? '#009EB4' : bookingDetailsdata?.bookingStatus === 'accepted' ? '#40B962' : bookingDetailsdata?.bookingStatus === 'cancelled' ? '#D81A23' : bookingDetailsdata?.bookingStatus === 'ongoing' ? '#1A44B8' : 'default',
                                                bgcolor: bookingDetailsdata?.bookingStatus === 'requested' ? '#FFEDD5' : bookingDetailsdata?.bookingStatus === "rejected" ? '#f800001f' : bookingDetailsdata?.bookingStatus === 'completed' ? '#009eb442' : bookingDetailsdata?.bookingStatus === 'accepted' ? '#40b96236' : bookingDetailsdata?.bookingStatus === 'cancelled' ? '#d81a233b' : bookingDetailsdata?.bookingStatus === 'ongoing' ? '#1a44b838' : 'default'
                                            }}
                                        />
                                        {/* <RoleGuard role={['Super Admin', 'Admin']} >
                                            {(bookingDetailsdata?.bookingStatus == 'accepted' || bookingDetailsdata?.bookingStatus == 'ongoing') &&
                                            <IconButton size='small' color='warning' sx={{fontSize:'0.85rem'}} onClick={()=>setChangeBookingStatus(true)}><Edit sx={{fontSize:'1rem'}}/></IconButton>
                                            }
                                        </RoleGuard> */}
                                        <PermissionGuard feature={'booking-status'} permission={'canEdit'} >
                                            {(  bookingDetailsdata?.bookingStatus == 'requested' || bookingDetailsdata?.bookingStatus == 'accepted' || bookingDetailsdata?.bookingStatus == 'ongoing') &&
                                            <IconButton size='small' color='warning' sx={{fontSize:'0.85rem'}} onClick={()=>setChangeBookingStatus(true)}><Edit sx={{fontSize:'1rem'}}/></IconButton>
                                            }
                                        </PermissionGuard>
                                    </>
                                }
                            </Box>

                        </Box>
                        <Box sx={{ my: '1%', px: '2%' }}>
                            <TableContainer component={Paper}>
                                <Table size='small'>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ fontWeight: 600, fontSize: '0.75rem' }}>Requested Services</TableCell>
                                            <TableCell sx={{ fontWeight: 600, fontSize: '0.75rem' }}>Quantity</TableCell>
                                            <TableCell sx={{ fontWeight: 600, fontSize: '0.75rem' }}>Time Slot</TableCell>
                                            <TableCell sx={{ fontWeight: 600, fontSize: '0.75rem', textAlign: 'right' }}>Price</TableCell>
                                            <TableCell sx={{ fontWeight: 600, fontSize: '0.75rem', textAlign: 'right' }}>Total</TableCell>
                                            <TableCell sx={{ fontWeight: 600, fontSize: '0.75rem', textAlign: 'right' }}>Action</TableCell>

                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {bookingDetailsdata?.bookingItems?.map((item, index) => (
                                            <TableRow key={index}>
                                                <TableCell sx={{ fontSize: '0.75rem', fontWeight: '500' }}>
                                                   { item?.providerServices && <Box component='span' sx={{ cursor: 'pointer', color: '#1976d2' }} onClick={() => window.open(`/admin/service-details/${item?.providerServices?.servicesChildId}`, '_blank')}>
                                                        {item?.providerServices?.servicesChildId}_
                                                    </Box>}
                                                    {/* _{item?.providerServices?.childService?.title} */}
                                                    {item?.serviceName} 
                                                    {item?.providerServices && item?.providerServices?.brd.id != '1' && <Box component={'span'} sx={{color:'#1976d2'}}>{`_${item?.providerServices?.brd?.title}`}</Box>}
                                                    {item?.providerServices && item.providerServices?.childService?.gstDetails?.sac && `(${item.providerServices?.childService?.gstDetails?.sac})`}
                                                </TableCell>
                                                <TableCell sx={{ fontSize: '0.75rem', pl: '3%' }}>{item.quantity}</TableCell>
                                                <TableCell sx={{ fontSize: '0.75rem' }}>
                                                    {dayjs(bookingDetailsdata?.bookingStartTime, 'HH:mm:ss').format('h:mm A')} -
                                                    {dayjs(bookingDetailsdata?.bookingEndTime, 'HH:mm:ss').format('h:mm A')}
                                                </TableCell>
                                                <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>₹{item.price}</TableCell>
                                                <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>₹{(item.price * item.quantity).toFixed(2)}</TableCell>
                                                {/* <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>View Details</TableCell> */}
                                                <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>
                                                    <Button 
                                                        size="small" 
                                                        variant="outlined" 
                                                        sx={{ textTransform: 'none', fontSize: '0.65rem', py: 0 }}
                                                        onClick={() => handleViewItemDetails(item)}
                                                    >
                                                        View Details
                                                    </Button>
                                                </TableCell>

                                            </TableRow>
                                        ))}

                                        {/* Charges Section */}
                                        
                                                    <TableRow>
                                                        <TableCell rowSpan={chargeDetails.length + 1} sx={{ borderBottom: 'none' }} />
                                                        <TableCell colSpan={3} sx={{ textAlign: 'right', fontWeight: '600', borderBottom: 'none', fontSize: '0.75rem', py: 0.15 }}>
                                                            SubTotal:
                                                        </TableCell>
                                                        <TableCell sx={{ textAlign: 'right', borderBottom: 'none', fontSize: '0.75rem', py: 0.15 }}>
                                                            ₹{bookingDetailsdata?.subTotal}
                                                        </TableCell>
                                                    </TableRow>

                                                    {chargeDetails.map((charge, idx) => (
                                                        <TableRow key={idx} >
                                                            <TableCell colSpan={3} sx={{verticalAlign:'baseline' ,textAlign: 'right', fontSize: '0.75rem', borderBottom: 'none', py: 0.15, color: charge.color }}>
                                                                {charge.label}:
                                                            </TableCell>
                                                            {
                                                                charge.label == 'Coupon Applied' ?
                                                                    charge.value > 0 ?
                                                                        <TableCell sx={{ textAlign: 'right', borderBottom: 'none', py: 0.15, color: charge.color }}>
                                                                            <Typography sx={{ fontSize: '0.75rem', }}>
                                                                                ₹{charge.value.toFixed(2) || 0.00}
                                                                            </Typography>
                                                                            {bookingDetailsdata?.couponDetails &&
                                                                                <Box sx={{}}>
                                                                                    <Box sx={{display:'flex',alignItems:'center',justifyContent:'end'}}>
                                                                                    <Typography sx={{fontSize: '0.55rem',border:'1px dashed red',p:'.6% 2%',fontWeight:600,bgcolor:'#1565c0',color:'#fff'}}>
                                                                                        {bookingDetailsdata?.couponDetails.couponCode}
                                                                                    </Typography>
                                                                                    {/* <IconButton sx={{p:0}} size='small' color='error' onClick={()=>removeCouponDiscount()}><Close sx={{fontSize:'1rem'}}/></IconButton> */}
                                                                                        {(bookingDetailsdata?.bookingStatus == 'requested' && bookingDetailsdata?.payment?.paymentMethod != 'RAZORPAY')&&
                                                                                            <Button sx={{ p: 0, fontSize: '.75rem' }} size='small' color='error' onClick={() => removeCouponDiscount()}>Remove </Button>
                                                                                        }
                                                                                    </Box>
                                                                                </Box>
                                                                            }
                                                                        </TableCell>
                                                                        :
                                                                        // (bookingDetailsdata?.bookingStatus != 'ongoing' && bookingDetailsdata?.bookingStatus != 'accepted' && bookingDetailsdata?.bookingStatus != 'completed' && bookingDetailsdata?.bookingStatus != 'cancelled') ?
                                                                            (bookingDetailsdata?.bookingStatus == 'requested' && bookingDetailsdata?.payment?.paymentMethod != 'RAZORPAY')?
                                                                             <TableCell sx={{ textAlign: 'right', fontSize: '0.75rem', borderBottom: 'none', py: 0.15 }}>
                                                                                <Typography sx={{ cursor: 'pointer', color: '#1976d2', fontSize: '0.65rem' }} onClick={() => setOpenDiscountModal(true)}>Apply Coupon</Typography>
                                                                            </TableCell>
                                                                            :
                                                                            <TableCell sx={{ textAlign: 'right', fontSize: '0.75rem', borderBottom: 'none', py: 0.15, color: charge.color }}>
                                                                                ₹{charge.value.toFixed(2) || 0.00}
                                                                            </TableCell>
                                                                    :
                                                                    <TableCell sx={{ textAlign: 'right', fontSize: '0.75rem', borderBottom: 'none', py: 0.15, color: charge.color }}>
                                                                        ₹{charge.value.toFixed(2)||0.00}
                                                                    </TableCell>
                                                            }
                                                        </TableRow>
                                                    ))}
                                                {/* </>
                                            );
                                        })()} */}

                                        {/* Total Amount */}
                                        <TableRow sx={{ borderTop: '1px solid lightGray', }}>
                                            <TableCell colSpan={4} sx={{ textAlign: 'right', fontWeight: '600', borderBottom: 'none', fontSize: '0.75rem' }}>
                                                Total Amount:
                                            </TableCell>
                                            <TableCell sx={{ textAlign: 'right', fontWeight: '600', borderBottom: 'none', fontSize: '0.75rem' }}>
                                                ₹{bookingDetailsdata?.total}
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>

                        </Box>
                        {/* ===========customer detail section==================== */}
                        <Box sx={{ my: '1%', px: '2%' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                <Typography sx={{ fontWeight: '600', fontSize: '0.75rem' }}>Customer Details</Typography>
                                <AccountCircle sx={{ fontSize: '1rem' }} />
                            </Box>
                            <Paper sx={{ p: '2%' }}>
                                <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
                                    <Typography fontWeight={'600'} sx={{ width: '30%', color: '#3E3E3E', fontSize: '0.75rem' }}>Name</Typography>
                                    <Typography fontWeight={'600'} sx={{ mr: '1%', fontSize: '0.65rem' }}>:</Typography>
                                    <Typography fontWeight={'400'} sx={{ fontSize: '0.65rem', textTransform: 'capitalize', color: '#181818' }}>
                                        {bookingDetailsdata?.customerName}
                                        <Box component={'span'} sx={{ cursor: 'pointer', fontSize: '0.5rem', color: '#1976d2', ml: '.25rem' }} onClick={() => window.open(`/admin/customerProfile/${bookingDetailsdata?.customerId}`, '_blank')}>
                                            ({bookingDetailsdata?.customerId})
                                        </Box>
                                    </Typography>
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
                                    <Typography fontWeight={'600'} sx={{ width: '30%', color: '#3E3E3E', fontSize: '0.75rem' }}>Contact</Typography>
                                    <Typography fontWeight={'600'} sx={{ mr: '1%', fontSize: '0.65rem' }}>:</Typography>
                                    <Typography fontWeight={'400'} sx={{ fontSize: '0.65rem', width: '68%', color: '#181818' }}>{bookingDetailsdata?.add_mobileNumber || bookingDetailsdata?.customer?.mobileNumber}</Typography>
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
                                    <Typography fontWeight={'600'} sx={{ width: '30%', color: '#3E3E3E', fontSize: '0.75rem' }}>Address</Typography>
                                    <Typography fontWeight={'600'} sx={{ mr: '1%', fontSize: '0.65rem' }}>:</Typography>
                                    <Typography fontWeight={'400'} sx={{ fontSize: '0.65rem', width: '68%', color: '#181818' }}>{bookingDetailsdata?.add_address}
                                        {(bookingDetailsdata?.add_longitude && bookingDetailsdata?.add_latitude) && <Box component={'span'} sx={{ ml: '1%' }}>
                                            {/* <AssistantDirection color='primary' sx={{fontSize:'1rem',cursor:'pointer'}} onClick={()=>window.open(`https://www.google.com/maps/dir/?api=1&destination=${bookingDetailsdata?.add_latitude},${bookingDetailsdata?.add_longitude}`,'blank')}/> */}
                                            <Tooltip
                                                open={openTooltip}
                                                onOpen={() => setOpenTooltip(true)}
                                                onClose={() => setOpenTooltip(false)}
                                                componentsProps={{
                                                    tooltip: {
                                                        sx: {
                                                            padding: 0,
                                                            bgcolor: 'transparent',
                                                        },
                                                    },
                                                }}
                                                title={
                                                    <Paper sx={{ py: 1 }}>
                                                        <Typography
                                                            sx={{
                                                                cursor: 'pointer',
                                                                fontSize: '0.65rem',
                                                                p: 1,
                                                                '&:hover': {
                                                                    backgroundColor: 'primary.dark',
                                                                    color: '#fff',
                                                                },
                                                            }}
                                                            onClick={handleCopy}
                                                        >
                                                            Copy Link Address
                                                        </Typography>
                                                        <Typography
                                                            sx={{
                                                                cursor: 'pointer',
                                                                fontSize: '0.65rem',
                                                                p: 1,
                                                                '&:hover': {
                                                                    backgroundColor: 'primary.dark',
                                                                    color: '#fff',
                                                                },
                                                            }}
                                                            onClick={handleOpenInNewTab}
                                                        >
                                                            Open Address in new tab
                                                        </Typography>
                                                    </Paper>
                                                }
                                                placement="bottom-start"
                                                PopperProps={{
                                                    modifiers: [
                                                        {
                                                            name: 'offset',
                                                            options: {
                                                                offset: [0, -10],
                                                            },
                                                        },
                                                    ],
                                                }}
                                                enterDelay={200}
                                                leaveDelay={200}
                                            >
                                                {/* <IconButton onClick={() => setOpenTooltip(prev => !prev)}> */}
                                                <AssistantDirection color="primary" sx={{ fontSize: '1rem', cursor: 'pointer' }} />
                                                {/* </IconButton> */}
                                            </Tooltip>
                                            <Snackbar
                                                open={snackbarOpen}
                                                autoHideDuration={2000}
                                                onClose={() => setSnackbarOpen(false)}
                                                message="Link copied!"
                                                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                                            >
                                                <SnackbarContent
                                                    sx={{
                                                        // backgroundColor: 'background.paper',
                                                        // color: 'text.primary',
                                                        // border: '1px solid',
                                                        // borderColor: 'primary.main',
                                                        boxShadow: 3,
                                                        px: 2,
                                                        py: 1,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: 1,
                                                        borderRadius: 4,
                                                    }}
                                                    message={
                                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                                            <LinkIcon sx={{ fontSize: '1rem', mr: 1 }} />
                                                            Link copied!
                                                        </span>
                                                    }
                                                />
                                            </Snackbar>
                                        </Box>}
                                    </Typography>
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
                                    <Typography fontWeight={'600'} sx={{ width: '30%', color: '#3E3E3E', fontSize: '0.75rem' }}>Landmark</Typography>
                                    <Typography fontWeight={'600'} sx={{ mr: '1%', fontSize: '0.65rem' }}>:</Typography>
                                    <Typography fontWeight={'400'} sx={{ fontSize: '0.65rem', width: '68%', color: '#181818' }}>{bookingDetailsdata?.add_landmark}</Typography>
                                </Box>
                            </Paper>
                        </Box>
                        {/* ============provider detail section=================== */}
                        <Box sx={{ my: '1%', px: '2%' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                <Typography sx={{ fontWeight: '600', fontSize: '0.75rem' }}>Provider Details</Typography>
                                <PersonOutline sx={{ fontSize: '1rem' }} />

                            </Box>
                            <Box sx={{ display: { xs: 'block', sm: 'flex' }, alignItems: 'baseline', gap: 2 }}>
                                <Paper sx={{ p: '2%', flex: 1 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                        <Typography fontWeight={'600'} sx={{ width: '45%', color: '#3E3E3E', fontSize: '0.75rem' }}>Name</Typography>
                                        <Typography fontWeight={'600'} sx={{ mr: '1%', fontSize: '0.65rem' }}>:</Typography>
                                        <Typography fontWeight={'400'} sx={{ fontSize: '0.65rem', textTransform: 'capitalize', color: '#181818' }}>
                                            {bookingDetailsdata?.providerName}
                                            <Box component={'span'} sx={{ cursor: 'pointer', fontSize: '0.5rem', color: '#1976d2', ml: '.25rem' }} onClick={() => window.open(`/admin/expert-detail/${bookingDetailsdata?.providerId}`, '_blank')}>
                                                ({bookingDetailsdata?.providerId})
                                            </Box>
                                        </Typography>
                                    </Box>
                                    <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                        <Typography fontWeight={'600'} sx={{ width: '45%', color: '#3E3E3E', fontSize: '0.75rem' }}>Contact</Typography>
                                        <Typography fontWeight={'600'} sx={{ mr: '1%', fontSize: '0.65rem' }}>:</Typography>
                                        <Typography fontWeight={'400'} sx={{ fontSize: '0.65rem' }}>{bookingDetailsdata?.provider?.mobileNumber || ''}</Typography>
                                    </Box>
                                    <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                        <Typography fontWeight={'600'} sx={{ width: '45%', color: '#3E3E3E', fontSize: '0.75rem' }}>waiveVisitCharge</Typography>
                                        <Typography fontWeight={'600'} sx={{ mr: '1%', fontSize: '0.65rem' }}>:</Typography>
                                        <Typography fontWeight={'400'} sx={{ fontSize: '0.65rem' }}>₹{bookingDetailsdata?.provider?.UserProfile?.waiveVisitCharge || '0.00'}</Typography>
                                    </Box>
                                </Paper>
                                <Paper sx={{ p: '2%', flex: 1.5 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                        <Typography fontWeight={'600'} sx={{ width: '40%', color: '#3E3E3E', fontSize: '0.75rem' }}>Avg. Rating</Typography>
                                        <Typography fontWeight={'600'} sx={{ mr: '1%', fontSize: '0.65rem' }}>:</Typography>
                                        <Rating name="half-rating-read" defaultValue={0} precision={0.5} value={bookingDetailsdata?.provider?.avgRating || 0} readOnly size='small' />
                                        <Typography fontWeight={'400'} sx={{ fontSize: '0.65rem', textTransform: 'capitalize', color: '#181818' }}>{`(${bookingDetailsdata?.provider?.countRating || 0})`}</Typography>
                                    </Box>
                                    <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                        <Typography fontWeight={'600'} sx={{ width: '40%', color: '#3E3E3E', fontSize: '0.75rem' }}>Customer Rating</Typography>
                                        <Typography fontWeight={'600'} sx={{ mr: '1%', fontSize: '0.65rem' }}>:</Typography>
                                        <Rating name="half-rating-read" defaultValue={0} precision={0.5} value={bookingDetailsdata?.rating?.rating || 0} readOnly size='small' />
                                        {/* <Typography fontWeight={'400'} sx={{fontSize:'0.65rem',textTransform:'capitalize',color:'#181818'}}>{bookingDetailsdata?.providerName}</Typography>     */}
                                    </Box>
                                    <Box sx={{ display: 'flex' }}>
                                        <Typography fontWeight={'600'} sx={{ width: '40%', color: '#3E3E3E', fontSize: '0.75rem' }}>Customer Comment</Typography>
                                        <Typography fontWeight={'600'} sx={{ mr: '1%', fontSize: '0.65rem' }}>:</Typography>
                                        <Typography fontWeight={'400'} sx={{ fontSize: '0.65rem', textWrap: 'wrap', width: '58%' }}>{bookingDetailsdata?.rating?.comment || 'N/A'}</Typography>
                                    </Box>
                                </Paper>
                            </Box>
                        </Box>
                        <Box sx={{display:'flex',justifyContent:'space-between',alignItems:'center',my: '1%', px: '2%'}}>
                            <IsTestBooking isTestBooking={bookingDetailsdata?.isTestBooking} fetchData={fetchBookingDetalById} />
                            {bookingDetailsdata?.bookingStatus == 'completed' &&
                                <img
                                    src={pdfLogo}
                                    alt="download_pdf_logo"
                                    style={{ width: "2rem", height: "2rem", cursor: "pointer" }}
                                    onClick={() => downloadInvoice(bookingId)}
                                />
                            }
                            <CouponAmountCalculator bookingDetailsdata={bookingDetailsdata} fetchBookingDetalById={fetchBookingDetalById} label={'text'}/>
                        </Box>
                    </Card>
                </Grid>
                {/* ============right section====================== */}
                <Grid item xs={12} md={3.5}>
                    <PermissionGuard feature='booking' permission='canEdit'>
                        {bookingDetailsdata && !(bookingDetailsdata?.bookingStatus == 'rejected' || bookingDetailsdata?.bookingStatus == 'cancelled' || bookingDetailsdata?.bookingStatus == 'completed' || bookingDetailsdata?.bookingStatus == 'ongoing') &&
                            <CancelAndReschedule fetchBookingDetalById={fetchBookingDetalById} bookingDetailsdata={bookingDetailsdata} />
                        }
                    </PermissionGuard>
                    {(bookingDetailsdata?.bookingStatus == 'rejected' || bookingDetailsdata?.bookingStatus == 'cancelled') && (
                        <Card sx={{ mb: '2%' }}>
                            <Box sx={{}}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, p: '1% 2%', borderBottom: '1px solid lightGray' }}>
                                    <Typography sx={{ fontWeight: '600', fontSize: '0.85rem' }}>{`Booking ${bookingDetailsdata?.bookingStatus == 'rejected' ? 'Rejection' : 'Cancellation'} Details`}</Typography>
                                </Box>
                                <Box sx={{ p: '1% 2%' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <Typography fontWeight={'600'} sx={{ width: '30%', color: '#3E3E3E', fontSize: '0.65rem' }}>Cancelled By</Typography>
                                        <Typography fontWeight={'600'} sx={{ mr: '1%' }}>:</Typography>
                                        <Typography fontWeight={'400'} sx={{ fontSize: '0.65rem', textTransform: 'capitalize', color: '#181818' }}>{(bookingDetailsdata?.cancelBy)?.replace(/_/g, " ")}</Typography>
                                        { (bookingDetailsdata?.cancelBy == 'customer_support' && bookingDetailsdata?.cancelInfo) && (
                                            <Tooltip
                                                componentsProps={{
                                                    tooltip: {
                                                        sx: {
                                                            padding: '0',
                                                            bgcolor: 'transparent'  // if you also want to remove background
                                                        }
                                                    }
                                                }}
                                                title={
                                                    <Paper sx={{ p: 1 ,width:'max-content',bgcolor:'#dde4ea'}}>
                                                        <Box sx={{ display: 'flex', alignItems: 'baseline',borderBottom:'1px solid lightGray',pb:0.5,mb:0.5 }}>
                                                            <Typography fontWeight={'600'} sx={{ width: '30%', color: '#3E3E3E', fontSize: '0.75rem' }}>On Behalf</Typography>
                                                            <Typography fontWeight={'600'} sx={{ mr: '1%' }}>:</Typography>
                                                            <Typography fontWeight={'400'} sx={{ fontSize: '0.75rem', width: '68%', color: '#181818' }}>{bookingDetailsdata?.cancelInfo?.cancelOnBehalf}</Typography>
                                                        </Box>
                                                        <Box sx={{ display: 'flex', alignItems: 'baseline',borderBottom:'1px solid lightGray',pb:0.5,mb:0.5 }}>
                                                            <Typography fontWeight={'600'} sx={{ width: '30%', color: '#3E3E3E', fontSize: '0.75rem' }}>Name</Typography>
                                                            <Typography fontWeight={'600'} sx={{ mr: '1%' }}>:</Typography>
                                                            <Typography fontWeight={'400'} sx={{ fontSize: '0.75rem', width: '68%', color: '#181818' }}>{bookingDetailsdata?.cancelInfo?.adminName}</Typography>
                                                        </Box>
                                                        <Box sx={{ display: 'flex', alignItems: 'baseline',borderBottom:'1px solid lightGray',pb:0.5,mb:0.5 }}>
                                                            <Typography fontWeight={'600'} sx={{ width: '30%', color: '#3E3E3E', fontSize: '0.75rem' }}>Role</Typography>
                                                            <Typography fontWeight={'600'} sx={{ mr: '1%' }}>:</Typography>
                                                            <Typography fontWeight={'400'} sx={{ fontSize: '0.75rem', width: '68%', color: '#181818' }}>{bookingDetailsdata?.cancelInfo?.adminRole}</Typography>
                                                        </Box>
                                                        <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
                                                            <Typography fontWeight={'600'} sx={{ width: '30%', color: '#3E3E3E', fontSize: '0.75rem' }}>Email</Typography>
                                                            <Typography fontWeight={'600'} sx={{ mr: '1%' }}>:</Typography>
                                                            <Typography fontWeight={'400'} sx={{ fontSize: '0.75rem', width: '69%', color: '#181818' }}>{bookingDetailsdata?.cancelInfo?.adminEmail}</Typography>
                                                        </Box>
                                                    </Paper>
                                                }
                                            placement="bottom-start"  // You can change this to any valid placement
                                            PopperProps={{
                                                modifiers: [
                                                {
                                                    name: 'offset',
                                                    options: {
                                                    offset: [0, -10], // Horizontal and vertical offset
                                                    },
                                                },
                                                ],
                                            }}
                                            enterDelay={200}
                                            leaveDelay={200}
                                            >
                                                <InfoOutlined color="primary" sx={{ fontSize: '1rem', cursor: 'pointer', ml: 0.5,p:0 }} />
                                            </Tooltip>
                                        )}
                                    </Box>
                                    
                                    <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
                                        <Typography fontWeight={'600'} sx={{ width: '30%', color: '#3E3E3E', fontSize: '0.65rem' }}>Reason for {bookingDetailsdata?.bookingStatus == 'rejected' ? 'Rejection' : 'Cancellation'}</Typography>
                                        <Typography fontWeight={'600'} sx={{ mr: '1%' }}>:</Typography>
                                        <Typography fontWeight={'400'} sx={{ fontSize: '0.65rem', width: '68%', color: '#181818' }}>{bookingDetailsdata?.cancelMessage || bookingDetailsdata?.message || ''}</Typography>
                                    </Box>
                                </Box>
                            </Box>
                        </Card>
                    )}
                    {/* {(loggedUser?.role.title == 'Super Admin' && bookingDetailsdata?.startOTP && !(bookingDetailsdata?.bookingStatus == 'rejected' || bookingDetailsdata?.bookingStatus == 'cancelled')) &&
                        <OtpSection bookingDetailsdata={bookingDetailsdata} />
                    } */}
                    <RoleGuard role={'Super Admin'}>
                        {(loggedUser?.role.title == 'Super Admin' && bookingDetailsdata?.startOTP && !(bookingDetailsdata?.bookingStatus == 'rejected' || bookingDetailsdata?.bookingStatus == 'cancelled')) &&
                        <OtpSection bookingDetailsdata={bookingDetailsdata} />
                    }
                    </RoleGuard>
                    <BookingLogs />
                    <PaymentDetails />
                </Grid>
                {!showChat &&
                    <Badge
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        sx={{
                            position: 'fixed',
                            bottom: 5,
                            right: 15,
                        }}
                        badgeContent={badgeContent}
                        color={badgeContent > 0 ? "success" : "error"}
                        showZero
                    >
                        <Fab
                            variant="extended"
                            size="small"
                            color="primary"
                            disabled={badgeContent==0}
                            sx={{
                                textTransform: 'capitalize',
                                fontSize: { xs: '0.75rem', md: '1rem' },
                                height: { xs: '1.5rem', md: '2rem' }
                            }}
                            onClick={() => setShowChat(!showChat)}
                        >
                            <Chat sx={{ mr: 1, fontSize: { xs: '0.75rem', md: '1rem' } }} />
                            Show Chat
                        </Fab>
                    </Badge>
                }
                {showChat && (
                    <Card sx={{
                        position: 'fixed',
                        bottom: 5,
                        right: 5,
                        width: { xs: '75%', sm: '40%', md: '25%' },
                        height: '75vh',
                        zIndex: 1050,
                        overflow: 'hidden',
                        border: '1px solid #6256e6'
                    }}>
                        <ChatBox
                            onClose={() => setShowChat(false)}
                            bookingDetails={bookingDetailsdata}
                            setBadgeContent={setBadgeContent}
                            isChatLoading={isChatLoading}
                            messages={messages}
                            fetchMessages={fetchMessages}
                        />
                    </Card>
                )}
            </Grid>
            {/* aaply discount modal */}
            <Modal
                open={openDiscountModal}
                // onClose={() => setOpenServiceDropdown(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                sx={{ overflow: "scroll" }}
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: { xs: '50%', sm: '50%' },
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        bgcolor: 'background.paper',
                        p: 0,
                        width: { xs: "95%", sm: "30%" },
                        minHeight: '25%'
                    }}

                    borderRadius={2}
                >
                    <Box sx={{ borderBottom: '1px solid lightGray', display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: '1% 2%' }}>
                        <Typography sx={{ fontWeight: 600, fontSize: '.9rem' }} >
                            Coupon Detail's
                        </Typography>
                        <IconButton
                            size='small'
                            onClick={() => setOpenDiscountModal(false)}
                            sx={{ p: 0 }}
                            color='error'
                        >
                            <Close sx={{ fontSize: { xs: '1rem', sm: '1.25rem' } }} />
                        </IconButton>
                    </Box>
                    <ApplyDiscount setOpenDiscountModal={setOpenDiscountModal} />
                </Box>
            </Modal>
            {/* Item Details Modal */}
            <Modal
                open={openItemDetails}
                onClose={() => setOpenItemDetails(false)}
                aria-labelledby="item-details-modal-title"
                aria-describedby="item-details-modal-description"
                sx={{ overflow: "scroll" }}
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: { xs: '50%', sm: '50%' },
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        bgcolor: 'background.paper',
                        p: 0,
                        width: { xs: "95%", sm: "90%", md: "85%" },
                        maxHeight: '90vh',
                        overflowY: 'auto',
                    }}
                    borderRadius={2}
                >
                    <Box sx={{ borderBottom: '1px solid lightGray', display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: '1% 2%' }}>
                        <Typography sx={{ fontWeight: 600, fontSize: '.9rem' }} id="item-details-modal-title">
                            Item Detail's
                        </Typography>
                        <IconButton
                            size='small'
                            onClick={() => setOpenItemDetails(false)}
                            sx={{ p: 0 }}
                            color='error'
                        >
                            <Close sx={{ fontSize: { xs: '1rem', sm: '1.25rem' } }} />
                        </IconButton>
                    </Box>
                    <Box sx={{ p: '2%' }}>
                        <TableContainer component={Paper}>
                            <Table size='small'>
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ fontWeight: 600, fontSize: '0.75rem' }}>Service Name</TableCell>
                                        <TableCell sx={{ fontWeight: 600, fontSize: '0.75rem', textAlign: 'center' }}>Qty</TableCell>
                                        <TableCell sx={{ fontWeight: 600, fontSize: '0.75rem', textAlign: 'right' }}>Base Amt</TableCell>
                                        <TableCell sx={{ fontWeight: 600, fontSize: '0.75rem', textAlign: 'right' }}>Coin Discount</TableCell>
                                        <TableCell sx={{ fontWeight: 600, fontSize: '0.75rem', textAlign: 'right' }}>Coupon Discount</TableCell>
                                        <TableCell sx={{ fontWeight: 600, fontSize: '0.75rem', textAlign: 'right' }}>Total Discount</TableCell>

                                        <TableCell sx={{ fontWeight: 600, fontSize: '0.75rem', textAlign: 'right' }}>Taxable Amt</TableCell>
                                        <TableCell sx={{ fontWeight: 600, fontSize: '0.75rem', textAlign: 'right' }}>CGST</TableCell>
                                        <TableCell sx={{ fontWeight: 600, fontSize: '0.75rem', textAlign: 'right' }}>SGST</TableCell>
                                        <TableCell sx={{ fontWeight: 600, fontSize: '0.75rem', textAlign: 'right' }}>IGST</TableCell>
                                        <TableCell sx={{ fontWeight: 600, fontSize: '0.75rem', textAlign: 'right' }}>Total GST</TableCell>
                                        <TableCell sx={{ fontWeight: 600, fontSize: '0.75rem', textAlign: 'right' }}>Total Amt</TableCell>
                                        <TableCell sx={{ fontWeight: 600, fontSize: '0.75rem', textAlign: 'right' }}>Tax Rate</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {selectedItem && (
                                        <TableRow>
                                            <TableCell sx={{ fontSize: '0.75rem', fontWeight: '500' }}>
                                                {selectedItem?.serviceName} 
                                                {selectedItem?.providerServices && selectedItem?.providerServices?.brd.id != '1' && <Box component={'span'} sx={{color:'#1976d2'}}>{`_${selectedItem?.providerServices?.brd?.title}`}</Box>}
                                            </TableCell>
                                            <TableCell sx={{ fontSize: '0.75rem', textAlign: 'center' }}>{selectedItem?.quantity}</TableCell>
                                            <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>{parseFloat(selectedItem?.price || 0).toFixed(2)}</TableCell>                                            
                                            {/* <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>{(parseFloat(selectedItem?.coinDiscount || 0) + parseFloat(selectedItem?.couponDiscount || 0)).toFixed(2)}</TableCell>
                                            <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>{parseFloat(selectedItem?.taxableAmount || (selectedItem?.price * selectedItem?.quantity) || 0).toFixed(2)}</TableCell> */}
                                            <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>{parseFloat(selectedItem?.coinDiscAmt || 0).toFixed(2)}</TableCell>
                                            <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>{parseFloat(selectedItem?.couponDiscAmt || 0).toFixed(2)}</TableCell>
                                            <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>{parseFloat(selectedItem?.coinDiscAmt + selectedItem?.couponDiscAmt|| 0).toFixed(2)}</TableCell>

                                            <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>{parseFloat((selectedItem?.price * selectedItem?.quantity) || 0).toFixed(2)}</TableCell>
                                            <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>{parseFloat(selectedItem?.cgst || 0).toFixed(2)}</TableCell>
                                            <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>{parseFloat(selectedItem?.sgst || 0).toFixed(2)}</TableCell>
                                            <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>{parseFloat(selectedItem?.igst || 0).toFixed(2)}</TableCell>
                                            <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>{(parseFloat(selectedItem?.igst || 0) + parseFloat(selectedItem?.cgst || 0) + parseFloat(selectedItem?.sgst || 0)).toFixed(2)}</TableCell>
                                            {/* <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>{parseFloat(selectedItem?.subtotal || (selectedItem?.price * selectedItem?.quantity) || 0).toFixed(2)}</TableCell> */}
                                            <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>{(parseFloat(selectedItem?.totalAmt ))}</TableCell>
                                            <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>
                                                {
                                                    // (selectedItem?.taxableAmount > 0) ?
                                                    // `${(((parseFloat(selectedItem?.igst || 0) + parseFloat(selectedItem?.cgst || 0) + parseFloat(selectedItem?.sgst || 0)) / parseFloat(selectedItem?.taxableAmount)) * 100).toFixed(0)}%`
                                                    (selectedItem?.totalAmt > 0) ?
                                                    `${(((parseFloat(selectedItem?.igst || 0) + parseFloat(selectedItem?.cgst || 0) + parseFloat(selectedItem?.sgst || 0)) / parseFloat(selectedItem?.totalAmt)) * 100).toFixed(0)}%`
                                                    : '0%'
                                                }
                                            </TableCell>
                                        </TableRow>
                                    )}
                                    <TableRow>
                                        <TableCell sx={{ fontSize: '0.75rem', fontWeight: '500' }}>Visiting Charge</TableCell>
                                        <TableCell sx={{ fontSize: '0.75rem', textAlign: 'center' }}>1</TableCell>
                                        <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>{parseFloat(bookingDetailsdata?.visitingCharge || 0).toFixed(2)}</TableCell>
                                        <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>0.00</TableCell>
                                        <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>0.00</TableCell>
                                        <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>0.00</TableCell>

                                        <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>{parseFloat(bookingDetailsdata?.visitingCharge || 0).toFixed(2)}</TableCell>
                                        <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>{parseFloat(bookingDetailsdata?.b_igst > 0 ? 0 : (bookingDetailsdata?.visitingCharge || 0) * 0.09).toFixed(2)}</TableCell>
                                        <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>{parseFloat(bookingDetailsdata?.b_igst > 0 ? 0 : (bookingDetailsdata?.visitingCharge || 0) * 0.09).toFixed(2)}</TableCell>
                                        <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>{parseFloat(bookingDetailsdata?.b_igst > 0 ? (bookingDetailsdata?.visitingCharge || 0) * 0.18 : 0).toFixed(2)}</TableCell>
                                        <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>{((bookingDetailsdata?.visitingCharge || 0) > 0 ? parseFloat((bookingDetailsdata?.visitingCharge || 0) * 0.18) : 0).toFixed(2)}</TableCell>
                                        <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>{((bookingDetailsdata?.visitingCharge || 0) > 0 ? parseFloat((bookingDetailsdata?.visitingCharge || 0) * 1.18) : 0).toFixed(2)}</TableCell>
                                        <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>{((bookingDetailsdata?.visitingCharge || 0) > 0 ? '18%' : '0%')}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ fontSize: '0.75rem', fontWeight: '500' }}>Convenience Fee</TableCell>
                                        <TableCell sx={{ fontSize: '0.75rem', textAlign: 'center' }}>1</TableCell>
                                        <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>{parseFloat(bookingDetailsdata?.convenienceFee || 0).toFixed(2)}</TableCell>
                                        <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>0.00</TableCell>
                                        <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>0.00</TableCell>
                                        <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>0.00</TableCell>
                                        
                                        <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>{parseFloat(bookingDetailsdata?.convenienceFee || 0).toFixed(2)}</TableCell>
                                        <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>{parseFloat(bookingDetailsdata?.b_igst > 0 ? 0 : (bookingDetailsdata?.convenienceFee || 0) * 0.09).toFixed(2)}</TableCell>
                                        <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>{parseFloat(bookingDetailsdata?.b_igst > 0 ? 0 : (bookingDetailsdata?.convenienceFee || 0) * 0.09).toFixed(2)}</TableCell>
                                        <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>{parseFloat(bookingDetailsdata?.b_igst > 0 ? (bookingDetailsdata?.convenienceFee || 0) * 0.18 : 0).toFixed(2)}</TableCell>
                                        <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>{((bookingDetailsdata?.convenienceFee || 0) > 0 ? parseFloat((bookingDetailsdata?.convenienceFee || 0) * 0.18) : 0).toFixed(2)}</TableCell>
                                        <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>{((bookingDetailsdata?.convenienceFee || 0) > 0 ? parseFloat((bookingDetailsdata?.convenienceFee || 0) * 1.18) : 0).toFixed(2)}</TableCell>
                                        <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>{((bookingDetailsdata?.convenienceFee || 0) > 0 ? '18%' : '0%')}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ fontSize: '0.75rem', fontWeight: '500' }}>Platform Charges</TableCell>
                                        <TableCell sx={{ fontSize: '0.75rem', textAlign: 'center' }}>1</TableCell>
                                        <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>{parseFloat(bookingDetailsdata?.platformCharges || 0).toFixed(2)}</TableCell>
                                        <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>0.00</TableCell>
                                        <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>0.00</TableCell>
                                        <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>0.00</TableCell>

                                        <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>{parseFloat(bookingDetailsdata?.platformCharges || 0).toFixed(2)}</TableCell>
                                        <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>{parseFloat(bookingDetailsdata?.b_igst > 0 ? 0 : (bookingDetailsdata?.platformCharges || 0) * 0.09).toFixed(2)}</TableCell>
                                        <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>{parseFloat(bookingDetailsdata?.b_igst > 0 ? 0 : (bookingDetailsdata?.platformCharges || 0) * 0.09).toFixed(2)}</TableCell>
                                        <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>{parseFloat(bookingDetailsdata?.b_igst > 0 ? (bookingDetailsdata?.platformCharges || 0) * 0.18 : 0).toFixed(2)}</TableCell>
                                        <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>{((bookingDetailsdata?.platformCharges || 0) > 0 ? parseFloat((bookingDetailsdata?.platformCharges || 0) * 0.18) : 0).toFixed(2)}</TableCell>
                                        <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>{((bookingDetailsdata?.platformCharges || 0) > 0 ? parseFloat((bookingDetailsdata?.platformCharges || 0) * 1.18) : 0).toFixed(2)}</TableCell>
                                        <TableCell sx={{ fontSize: '0.75rem', textAlign: 'right' }}>{((bookingDetailsdata?.platformCharges || 0) > 0 ? '18%' : '0%')}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Box>
            </Modal>

        </BookingDetailsContext.Provider>
    );
}

export default Viewdetails;
export { BookingDetailsContext };